import React, { useEffect } from 'react';
import { useFetch } from '../../utils/hooks/useFetch';
import { ContactUsApi } from '../../api/base/ContactUs';
import { Skeleton } from '@material-ui/lab';
import {Post } from "./Post";
import { useParams } from 'react-router';


export const EventPost: React.FC = () => {
  const params:any = useParams();
  const [{ response, isLoading }, doFetch] = useFetch(
      ContactUsApi.getSingleEventPosts,
    );
    
    useEffect(() => {
      doFetch(params.id);
    }, [doFetch]);

    

    return (
        <div>
            {isLoading ? (
              <Skeleton height={444} />
            ) : (
              response?.data?.data && <Post list={response?.data?.data || []} />            )}
        </div>
    )
}